import { render, staticRenderFns } from "./homeRecommend.vue?vue&type=template&id=5c294b14&scoped=true"
import script from "./homeRecommend.vue?vue&type=script&lang=js"
export * from "./homeRecommend.vue?vue&type=script&lang=js"
import style0 from "./homeRecommend.vue?vue&type=style&index=0&id=5c294b14&prod&lang=scss&scoped=true"
import style1 from "./homeRecommend.vue?vue&type=style&index=1&id=5c294b14&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c294b14",
  null
  
)

export default component.exports